import { useLayoutEffect } from "react";
import "@hagerty/global-header/build/index.css";
import {
  GlobalHeader,
  PrimaryHeader,
  PrimaryHeaderBranding,
  PrimaryHeaderNavLink,
} from "@hagerty/global-header";
import avatar from "./img/generic-avatar.png";
import style from "./Header.module.scss";

const branding: PrimaryHeaderBranding = {}; // use default logo and alt
const navigationLinks: PrimaryHeaderNavLink[] = [];

type HeaderProps = {
  firstName?: string;
  lastName?: string;
  hagertyHomeUrl: string;
  logoutUrl: string;
};

export const Header = ({
  firstName = "",
  lastName = "",
  hagertyHomeUrl,
  logoutUrl,
}: HeaderProps) => {
  const userMenuOptions = [
    <a className={style.menuItem} href={logoutUrl}>
      Log out
    </a>,
  ];

  const user = {
    firstName,
    lastName,
    avatar,
  };

  // HACK: PrimaryHeader doesn't support a custom href for the branding logo (they default to "/")
  // so change the href in the DOM after it's rendered. Note that there are two elements
  // returned: one logo in the header and another logo in the hamburger menu panel. If, for any
  // reason, there are no elements returned, the array below will be empty and we will "fail safe".
  // Because this hack relies on implementation details of the component, the version has been
  // pinned to 2.0.3. Note that support for a "simplified" header is coming soon that will make
  // this hack unnecessary.
  // see https://dev.azure.com/hagerty/Hagerty/_workitems/edit/84576/
  useLayoutEffect(() => {
    const linksNodeList = document.querySelectorAll(
      "#primary-navbar [data-testid='branding'] > a[href='/']"
    );
    const linkElements = [...linksNodeList] as HTMLLinkElement[];

    linkElements.forEach((linkElement) => {
      linkElement.href = hagertyHomeUrl;
    });
  }, [hagertyHomeUrl]);

  return (
    <GlobalHeader sticky className={style.container}>
      <PrimaryHeader
        navigationLinks={navigationLinks}
        branding={branding}
        user={user}
        userMenuOptions={userMenuOptions}
      />
    </GlobalHeader>
  );
};
